module.exports = __webpack_public_path__ + "article-7051a3ee/hobbys-lebenslauf-951e77329df0e022bf379788f609e5d4.jpg";